import React from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import TimeIcon from "../Assets/Icons/clockIcon.svg";
import Avatar from "../Assets/Avatar.png";
import Carousel from "../Components/Carousel";
import ProjectTitleDesc from "../Components/ProjectTitleDesc";
import FileIcon from "../Assets/filtIcon.png";
import ThreeDotsIcon from "../Assets/Icons/threeDots.svg";
import AvatarGroup from "../Components/AvatarGroup";
import TeamImg from "../Assets/TeamImg.png";

const descArray = [
  {
    heading: "About this AI Project",
    desc: "Lorem ipsum dolor sit amet consectetur. Elementum ante fermentum nisi vulputate velit viverra velit. In mauris cum risus massa at sapien sed lorem blandit. Lectus sagittis egestas diam auctor felis vivamus rhoncus vitae. Odio tortor erat orci vitae ipsum elit lacinia in turpis. Eu amet tristique turpis et amet turpis pellentesque sapien. Interdum duis nullam tincidunt amet penatibus porttitor vestibulum. Eget ut malesuada vulputate sit nulla mi sapien. Ipsum in gravida eu congue sed leo nibh vel. Commodo dictumst hac nunc vitae neque fermentum enim. Lacus eleifend at dui arcu porttitor suspendisse et ut vel.",
  },
  {
    heading: "Problem Description",
    desc: "Lorem ipsum dolor sit amet consectetur. Elementum ante fermentum nisi vulputate velit viverra velit. In mauris cum risus massa at sapien sed lorem blandit. Lectus sagittis egestas diam auctor felis vivamus rhoncus vitae. Odio tortor erat orci vitae ipsum elit lacinia in turpis. Eu amet tristique turpis et amet turpis pellentesque sapien. Interdum duis nullam tincidunt amet penatibus porttitor vestibulum. Eget ut malesuada vulputate sit nulla mi sapien. Ipsum in gravida eu congue sed leo nibh vel. Commodo dictumst hac nunc vitae neque fermentum enim. Lacus eleifend at dui arcu porttitor suspendisse et ut vel.",
  },
  {
    heading: "MVP Hypothesis",
    desc: "Lorem ipsum dolor sit amet consectetur. Elementum ante fermentum nisi vulputate velit viverra velit. In mauris cum risus massa at sapien sed lorem blandit. Lectus sagittis egestas diam auctor felis vivamus rhoncus vitae. Odio tortor erat orci vitae ipsum elit lacinia in turpis. Eu amet tristique turpis et amet turpis pellentesque sapien. Interdum duis nullam tincidunt amet penatibus porttitor vestibulum. Eget ut malesuada vulputate sit nulla mi sapien. Ipsum in gravida eu congue sed leo nibh vel. Commodo dictumst hac nunc vitae neque fermentum enim. Lacus eleifend at dui arcu porttitor suspendisse et ut vel.",
  },
  {
    heading: "Impact",
    desc: "Lorem ipsum dolor sit amet consectetur. Ut sodales lectus ipsum imperdiet et nisl volutpat purus consectetur. Non integer hac lacus ut. Senectus ipsum mi nulla sit. Mollis urna aliquet in sit.",
  },
  {
    heading: "Additional Information",
    desc: "Lorem ipsum dolor sit amet consectetur. Elementum ante fermentum nisi vulputate velit viverra velit. In mauris cum risus massa at sapien sed lorem blandit. Lectus sagittis egestas diam auctor felis vivamus rhoncus vitae. Odio tortor erat orci vitae ipsum elit lacinia in turpis. Eu amet tristique turpis et amet turpis pellentesque sapien. Interdum duis nullam tincidunt amet penatibus porttitor vestibulum. Eget ut malesuada vulputate sit nulla mi sapien. Ipsum in gravida eu congue sed leo nibh vel. Commodo dictumst hac nunc vitae neque fermentum enim. Lacus eleifend at dui arcu porttitor suspendisse et ut vel.",
  },
];
const ViewProjectNotAssigned = () => {
  return (
    <DashboardLayout>
      <section className="bg-white py-4 px-6 gap-y-5 w-full flex flex-col items-start">
        <Breadcrumbs
          links={[
            { name: "All AI Projects", link: "/" },
            { name: "Project Title", link: "/" },
          ]}
        />
        <div className="relative w-full h-[20rem]">
          <div className="w-full absolute left-0 top-0">
            <Carousel />
          </div>
        </div>
        <main className="w-full mt-1">
          <div className="flex items-start justify-between w-full">
            <div className="flex flex-col gap-y-2">
              <h1 className="text-2xl font-semibold text-gray-900">
                Project Title will be here
              </h1>
              <div className="flex items-center">
                <div className="px-3 py-1 w-fit rounded-[6px] bg-[#F3F4F6] flex items-center gap-2">
                  <img src={TimeIcon} />
                  <p className="text-xs text-[#111928] font-500">
                    Due in <span>Due in 21h 31m</span>
                  </p>
                </div>
                <span className="text-sm text-gray-500 ml-3">
                  Project started on 7/31/2023
                </span>
              </div>
            </div>
            <div>
              <ol className="flex items-center w-full space-x-2 text-sm font-medium text-center text-gray-500 sm:text-base  sm:space-x-4">
                <li className="flex items-center text-red-600">
                  <span className="flex items-center justify-center w-5 h-5 mr-2 text-xs border border-red-600 rounded-full shrink-0">
                    1
                  </span>
                  Ideation{" "}
                  <svg
                    className="w-3 h-3 ml-2 sm:ml-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 12 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="m7 9 4-4-4-4M1 9l4-4-4-4"
                    />
                  </svg>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-5 h-5 mr-2 text-xs border border-gray-500 rounded-full shrink-0">
                    2
                  </span>
                  Exploration{" "}
                  <svg
                    className="w-3 h-3 ml-2 sm:ml-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 12 10"
                  >
                    <path
                      stroke="#9CA3AF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="m7 9 4-4-4-4M1 9l4-4-4-4"
                    />
                  </svg>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-5 h-5 mr-2 text-xs border border-gray-500 rounded-full shrink-0">
                    3
                  </span>
                  Development{" "}
                  <svg
                    className="w-3 h-3 ml-2 sm:ml-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 12 10"
                  >
                    <path
                      stroke="#9CA3AF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="m7 9 4-4-4-4M1 9l4-4-4-4"
                    />
                  </svg>
                </li>
                <li className="flex items-center">
                  <span className="flex items-center justify-center w-5 h-5 mr-2 text-xs border border-gray-500 rounded-full shrink-0">
                    4
                  </span>
                  Deployment
                </li>
              </ol>
            </div>
          </div>
          <div className="flex items-center justify-between mt-3">
                <span className="text-sm text-gray-500">Not Assigned Yet</span>
                <button className='w-[10rem] h-[2.3rem] text-[0.90rem] text-white bg-[#942A27] rounded-[8px]'>Assign AI Team</button>
              </div>
        </main>
      </section>
      <section className="w-full bg-[#f9fafb] px-6 flex flex-col gap-y-4 py-6">
        {descArray?.map((descItem) => {
          return (
            <ProjectTitleDesc
              heading={descItem?.heading}
              desc={descItem?.desc}
            />
          );
        })}
        <section className="flex flex-col gap-y-2">
          <span className="text-md text-gray-900 font-medium">
            Documents describing this project
          </span>
          <div className="flex items-center border rounded-xl p-4 bg-white">
            <img src={FileIcon} alt="file" />
            <div className="flex flex-col items-start ml-4">
              <span>Tech requirements.pdf</span>
              <span>1.2 MB</span>
            </div>
          </div>
        </section>
        <ProjectTitleDesc
          heading="Link to a Description of the Project"
          desc="https://www.site.com/file/aOSKBXKhRDnpjLm3XriPJS/DAIMLAS"
        />

        <section className="flex flex-col gap-y-2">
          <span className="text-md text-gray-900 font-medium">
            About the AI Team
          </span>
          <div className="w-full p-4 border bg-white rounded-xl border-[#E5E7EB]">
            <div>
              <img src={TeamImg} />
            </div>
            <div className="flex flex-col gap-[2px] mt-[8px]">
              <h2 className="text-[1.1rem] font-[500] text-[#111928]">
                Team Name
              </h2>
              <p className="text-[0.90rem] text-[#6B7280]">
                Lorem ipsum dolor sit amet consectetur. Ultrices purus varius
                purus vel diam. Risus in egestas dui eget. Ut gravida sed cursus
                lorem viverra nunc vitae quis. Tellus nulla pharetra ullamcorper
                rhoncus consequat viverra id.
              </p>
            </div>
            <div className="flex items-center justify-between mt-5">
              <div className="flex flex-col gap-1">
                <p className="text-[0.90rem] text-[#6B7280]">Team members</p>
                <AvatarGroup />
              </div>
            </div>
          </div>
        </section>
      </section>
    </DashboardLayout>
  );
};

export default ViewProjectNotAssigned;
